"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Diamond(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement(
      "g",
      { transform: "translate(1 6)", fill: "none", fillRule: "evenodd" },
      _react2["default"].createElement("path", { fill: "#FF6A00", d: "M61.228 14.762l-30.285 39.51-.07-.098 15.022-39.412z" }),
      _react2["default"].createElement("path", { fill: "#FF8A3D", d: "M61.53 14.376l-.302.386H45.895L39.048.19h9.565zM21.872.19L15.257 14.76H.337L12.538.19z" }),
      _react2["default"].createElement("path", { fill: "#FF6A00", d: "M30.873 54.174L.336 14.762h14.92z" }),
      _react2["default"].createElement("path", { fill: "#FF8A3D", d: "M45.895 14.762L30.873 54.174 15.257 14.762z" }),
      _react2["default"].createElement("path", { fill: "#FFAC74", d: "M45.895 14.762H15.257L21.872.19h17.176z" })
    )
  );
}

exports["default"] = Diamond;
module.exports = exports["default"];